'use strict';


    var features = {};

    module.exports = {
        register: function (name, ctor) {
            features[name] = ctor;
        },

        get: function (name) {
            return features[name];
        }
    };



//////////////////
// WEBPACK FOOTER
// ./~/echarts/lib/component/toolbox/featureManager.js
// module id = 929
// module chunks = 0